exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".privacy-policy {\n  width: 90%;\n  max-width: 900px;\n  margin: 30px auto 0 auto; }\n  .privacy-policy .privacy-policy-container {\n    padding: 20px 40px;\n    width: 100%;\n    height: 100%;\n    background-color: #ffffff; }\n    .privacy-policy .privacy-policy-container .privacy-policy-heading {\n      margin-bottom: 35px;\n      text-align: center;\n      font-size: 32px; }\n    .privacy-policy .privacy-policy-container h3, .privacy-policy .privacy-policy-container .privacy-policy-heading {\n      color: #673bb7; }\n\n@media (max-width: 480px) {\n  .privacy-policy .privacy-policy-container {\n    padding: 10px 20px; } }\n\n@media (max-width: 375px) {\n  .privacy-policy .privacy-policy-container {\n    padding: 10px 15px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/privacy_policy/privacy_policy.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/privacy_policy/privacy_policy.scss
// module chunks = index